module.exports = __webpack_public_path__ + "img/main.7af4e915.png";